// Story dropdown functionality
document.addEventListener('DOMContentLoaded', () => {
  // Handle top dropdown
  const topBtn = document.getElementById('storyDropdownBtn');
  const topMenu = document.getElementById('storyMenu');
  
  if (topBtn && topMenu) {
    topBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      topMenu.classList.toggle('show');
      // Close bottom menu if open
      const bottomMenu = document.getElementById('storyMenuBottom');
      if (bottomMenu) bottomMenu.classList.remove('show');
    });
  }
  
  // Handle bottom dropdown
  const bottomBtn = document.getElementById('storyDropdownBtnBottom');
  const bottomMenu = document.getElementById('storyMenuBottom');
  
  if (bottomBtn && bottomMenu) {
    bottomBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      bottomMenu.classList.toggle('show');
      // Close top menu if open
      if (topMenu) topMenu.classList.remove('show');
    });
  }
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', () => {
    if (topMenu) topMenu.classList.remove('show');
    if (bottomMenu) bottomMenu.classList.remove('show');
  });
});

// Show All functionality
const showAllLinks = document.querySelectorAll('.show-all-link');
showAllLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    window.location.href = `/stories/${window.storySlug}/all/`;
  });
});
